<mat-dialog-content style="max-height: 60vw">
  <div id="w3l-appointment">
          <div class="header" style="display: flex;justify-content: center;">
          <h1 [(ngModel)]="docdepartment" style="display: flex; background-color: blue; color: white;align-self: center; padding:5px;border-radius: 25px;
    border: 1px solid blue; ">{{docdepartment}}</h1>
</div>

<div class="styled-input">
  <div class="accounts" style="left: 50px;">

    <div class="appointment-form-field">
      <label style="font-size: large;font-weight: bold;left: 150px;">     </label>

      <label style="font-size: large;font-weight: bold;left: 50px;">{{patientcode}}</label>
      <label style="font-size: large;font-weight: bold;left: 150px;">     </label>
      <label style="font-size: large;font-weight: bold;left: 190px;">{{Patientname}}</label>
    </div>
    <ul>
      <label style="font-size: large;font-weight: bold;left: 150px;">     </label>

      <label style="font-size: large;font-weight: bold;">Date :{{clinicdate}}</label>
      <label style="font-size: large;font-weight: bold;">     </label>
      <label style="font-size: large;font-weight: bold;">Time : {{clinictime}}</label>
      <label style="font-size: large;font-weight: bold;width: 20%;"></label>
      <label style="font-size: large;font-weight: bold;">Doctor :{{username}}</label>


    </ul>
  </div>
  <mat-divider></mat-divider>
  <br>
  <div class="appointment-form-field">
    <label style = "width: 20%;">Date </label>
    <input type="date" name="site" [(ngModel)]="clinicdate" style="width: 20%;" required="" />
    <label style = "width: 20%;"></label>
    <label style = "width: 15%; top:50%">Location </label>
      <select id="PatientStatus" name="PatientStatus" [(ngModel)]="cliniclocation" style="width: 33.5%;background-color:  rgb(187, 203, 238);"  required>
        <option value="{{doc.compCode}}"  *ngFor="let doc of companyList; let i = index">{{doc.compName}}</option>
      </select>
  </div>

</div>


  <br>
  <br>
  <br>
  <br>
  <div class="appointment-form-field">
    <angular-editor  [config]="editorConfigNoToolbar"  [placeholder]="'Enter text here...'" [(ngModel)]="clinicnotes" ></angular-editor>

  </div>

</div>
<BR>
<BR>
<BR>
<BR>
<BR>
<mat-divider></mat-divider>
  <BR>
<form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold;background-color: rgb(0, 86, 0);color: white; border-style: none;height: 60%;" name="submit" (click)="SubmitClinic()">{{ 'Submit' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px;font-weight: bold;background-color: rgb(1, 19, 58);color: white;border-style: none;height: 60%;" name="Back" (click)="Exit_Data()">{{ 'Home' | translate }}</button>
    <label style="width: 25%;"></label>
</form>

</mat-dialog-content>
